<template>
<div class="badge text-white" :class="variant">
    {{ psp }}
</div>
</template>

<script>
import Vue from 'vue'
import { pspNameStr, pspNameVariant } from '@/constants/pspRequestStatus'
export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    computed: {
        psp() {
            return pspNameStr.get(this.row.psp)
        },
        variant() {
            return 'badge-'+pspNameVariant(this.row.psp)
        }
    }
})
</script>

<style>
    .badge-novin{
        color: #fff;
        background-color: #683f84;
    }
    .badge-mellat{
        color: #fff;
        background-color: #ed1b2f;
    }
    .badge-saman{
        color: #fff;
        background-color: #07abea;
    }
</style>